import React from "react";
import CountDown from "../ManageBooking/CountDown";

const HomeBanner = ({ bookingDetails, currentTab }) => {
  const ImageToDisplay = {
    "View Reservations": "timer-bg.png",
    "Enhance Sailing": "EnhanceSellingBanner.png",
    "Upgrade Staterooms": "UpgradeStateroomBanner.png",
  };
  return (
    <div className="relative">
      <div>
        <img
          src={`${process.env.PUBLIC_URL}/assets/home/` + ImageToDisplay[currentTab]}
          alt="timer-bg"
          className="w-full h-[260px] md:h-auto"
        />
      </div>
      {currentTab === "View Reservations" && (
        <div className="absolute left-0 right-0 top-0 bottom-0 m-auto">
          {bookingDetails?.sailing_date && (
            <CountDown sailing_date={bookingDetails?.sailing_date} />
          )}
        </div>
      )}
    </div>
  );
};

export default HomeBanner;
